import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { logoutUser, clearTokens } from '../../api';
import './Sidebar.css';
import logo from "../../Asset/Yashavi.png";
import favicon from "../../Asset/favicon.png";

const Sidebar = ({ isOpen, toggleSidebar, darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Live time
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) =>
    date.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    }).toUpperCase();

  const formatDate = (date) =>
    date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

  // Logout with confirmation
  const handleLogoutClick = () => setShowLogoutModal(true);
  const confirmLogout = async () => {
    setShowLogoutModal(false);
    try {
      await logoutUser();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearTokens();
      navigate('/');
    }
  };
  const cancelLogout = () => setShowLogoutModal(false);

  const closeOnMobile = () => {
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  return (
    <>
      {/* Toggle Button */}
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        {isOpen ? '<' : '>'}   {/* {isOpen ? '=' : '+'} */}
      </button>

      <div className={`sidebar ${isOpen ? 'open' : 'closed'} ${darkMode ? 'dark' : ''}`}>

        {/* ── Header: Logo  */}
        <div className="sidebar-header">
          {isOpen ? (
            <img src={logo} alt="YashviTech" className="sidebar-logo" />
          ) : (
            <img src={favicon} alt="Y" className="sidebar-icon" />
          )}
        </div>

        {/* ── Time + Dark/Light Toggle ── */}
        <div className="sidebar-info-row">
          {isOpen && (
            <div className="sidebar-time">
              <span className="time-value">{formatTime(currentTime)}</span>
              <span className="date-value">{formatDate(currentTime)}</span>
            </div>
          )}

          <button
            className="theme-toggle-icon-btn"
            onClick={toggleDarkMode}
            title={darkMode ? 'Switch to Light' : 'Switch to Dark'}
          >
            {darkMode ? '☼' : '☾'}   {/* {darkMode ? '☀️' : '🌙'} */}
          </button>
        </div>

        {/* ── Menu ── */}
        <ul className="menu-list">
          <li>
            <NavLink to="/admin/dashboard" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeOnMobile} >
              <span className="icon">
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" > <path d="M3 10.5L12 3l9 7.5" /> <path d="M5 9.5V21h14V9.5" /> <path d="M9 21v-6h6v6" /> </svg>
              </span>
              {isOpen && <span className="label">Dashboard</span>}
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/contact" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeOnMobile} >
              <span className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <circle cx="12" cy="8" r="4" /> <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" /></svg>
              </span>
              {isOpen && <span className="label">Contact</span>}
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/product-enquiries" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeOnMobile} >
              <span className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                  <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
              </span>
              {isOpen && <span className="label">Product Enquiries</span>}
            </NavLink>
          </li>
          <li className="logout-item">
            <button onClick={handleLogoutClick} className="logout-btn">
              <span className="icon">↪</span>
              {isOpen && <span className="label">Logout</span>}
            </button>
          </li>
        </ul>
      </div>
      {/* ── Logout Confirmation Modal ── */}
      {showLogoutModal && (
        <div className="logout-modal-overlay" onClick={cancelLogout}>
          <div className="logout-modal" onClick={(e) => e.stopPropagation()}>
            <div className="logout-modal-icon">↪</div>
            <h3>Are you sure?</h3>
            <p>You will be logged out of your account.</p>
            <div className="logout-modal-actions">
              <button className="logout-modal-cancel" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="logout-modal-confirm" onClick={confirmLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;